const t = "得分：{{currentTime}}；總分：{{duration}}", A = "搜尋 {{current}} 結果，共 {{total}} 個", n = "找不到結果", o = "找到 {{count}} 個結果", E = "找到 {{count}} 個結果", c = '從 $t(HOURS, { "count": {{hours}} })、$t(MINUTES, { "count": {{minutes}} }) 和 $t(SECONDS, { "count": {{seconds}} }) 開始播放。', T = '從 $t(MINUTES, { "count": {{minutes}} }) 和 $t(SECONDS, { "count": {{seconds}} }) 開始播放。', _ = '從 $t(SECONDS, { "count": {{seconds}} }) 開始播放。', s = "將變更儲存到成績單時發生錯誤。", S = "在 {{time}} 的成績單行。內容為：{{text}}。", N = '成績單行容器。此容器內有 $t(TRANSCRIPT_LINES, { "count": {{count}} }) 行。若要在此容器內導航，請使用向下箭頭鍵。', R = "正在儲存變更中...", O = "變更已儲存到成績單中。", I = "更新標題按鈕現在可用。", C = "操作", P = "在 {{time}} 添加註釋", U = "在 {{time}} 添加問題", L = "註釋", D = "自動", e = "自動 ({{quality}})", M = "返回", u = "字幕", G = "字幕語言", Y = "管理字幕", H = "刪除 {{language}}", r = "字體大小", V = "字幕語言：{{language}}", B = "{{language}}（自動）", a = "清除搜尋", i = "關閉", K = "評論", m = "繼續", F = "減慢播放速度", d = "降低 {{percent}}% 音量", l = "下箭咀", h = "關閉成績單編輯器", W = "更新標題", $ = "錯誤！", g = "正在儲存...", Q = "已儲存！", J = "編輯成績單", p = "文字不可空白！", x = "全螢幕", Z = "{{count}} 小時", X = "{{count}} 小時", f = "加快播放速度", q = "調高 {{percent}}% 音量", v = "反轉色彩", y = "跳到特定百分比（1-10%、2-20% 等）", z = "跳到開始", b = "{{title}} 的動作", j = "鍵盤快速鍵", k = "語言", w = "左箭頭", tt = "主選單", At = "{{count}} 分鐘", nt = "{{count}} 分鐘", ot = "隱藏評分", Et = "已隱藏評分", ct = "下一個字幕語言", Tt = "下一個搜尋結果", _t = "關閉", st = "在頂部", St = "在 {{time}} 開啟註釋", Nt = "在{{time}} 開啟已完成的測驗", Rt = "在 {{time}} 開啟測驗", Ot = "暫停", It = "播放", Ct = "播放速度", Pt = "播放速度：{{speed}}x", Ut = "上一個字幕語言", Lt = "上一個搜尋結果", Dt = "質素", et = "品質選單", Mt = "重播", ut = "重設播放速度", Gt = "右箭頭", Yt = "在成績單中搜尋", Ht = "{{count}} 秒", rt = "{{count}} 秒", Vt = "向後搜尋：{{seconds}} 秒", Bt = "向前搜尋：{{seconds}} 秒", at = "設定", it = "快速鍵", Kt = "媒體詳細資料和工具", mt = "空格", Ft = "播放速度選單", dt = "開始自動捲動", lt = "字幕工具", ht = "切換靜音", Wt = "切換播放/暫停", $t = "有 {{count}} 個成績單行", gt = "有 {{count}} 個成績單行", Qt = "正在載入成績單中...", Jt = "我們無法載入成績單。", pt = "成績單選項", xt = "重試", Zt = "成績單不可用", Xt = "向上箭頭", ft = "影片設定", qt = "音量", vt = "音量：{{volume}}%", yt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: A,
  A11Y_SEARCH_NO_RESULTS: n,
  A11Y_SEARCH_RESULTS_FOUND: o,
  A11Y_SEARCH_RESULTS_FOUND_other: E,
  A11Y_TIMESTAMP_JUMP_HOURS: c,
  A11Y_TIMESTAMP_JUMP_MINUTES: T,
  A11Y_TIMESTAMP_JUMP_SECONDS: _,
  A11Y_TRANSCRIPT_ERROR: s,
  A11Y_TRANSCRIPT_LINE: S,
  A11Y_TRANSCRIPT_LINES: N,
  A11Y_TRANSCRIPT_SAVING: R,
  A11Y_TRANSCRIPT_SUCCESS: O,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: I,
  ACTION: C,
  ADD_ANNOTATION_AT: P,
  ADD_QUESTION_AT: U,
  ANNOTATIONS: L,
  AUTO: D,
  AUTO_QUALITY: e,
  BACK: M,
  CAPTIONS: u,
  CAPTIONS_LANGUAGE: G,
  CAPTIONS_MANAGE: Y,
  CAPTION_DELETE: H,
  CAPTION_FONT_SIZE: r,
  CAPTION_LANGUAGE: V,
  CAPTION_LANGUAGE_AUTOMATIC: B,
  CLEAR_SEARCH: a,
  CLOSE: i,
  COMMENTS: K,
  CONTINUE: m,
  DECREASE_PLAYBACK_SPEED: F,
  DECREASE_VOLUME: d,
  DOWN_ARROW: l,
  EDIT_CLOSE: h,
  EDIT_CONFIRM: W,
  EDIT_ERROR: $,
  EDIT_SAVING: g,
  EDIT_SUCCESS: Q,
  EDIT_TRANSCRIPT: J,
  EDIT_VALIDATION_ERROR: p,
  FULLSCREEN: x,
  HOURS: Z,
  HOURS_other: X,
  INCREASE_PLAYBACK_SPEED: f,
  INCREASE_VOLUME: q,
  INVERT_COLORS: v,
  JUMP_TO_PERCENTAGE: y,
  JUMP_TO_START: z,
  KEBAB_MENU: b,
  KEYBOARD_SHORTCUTS: j,
  LANGUAGE: k,
  LEFT_ARROW: w,
  MAIN_MENU: tt,
  MINUTES: At,
  MINUTES_other: nt,
  MUTE: ot,
  MUTED: Et,
  NEXT_CAPTION_LANGUAGE: ct,
  NEXT_HIT: Tt,
  OFF: _t,
  ON_TOP: st,
  OPEN_ANNOTATION_AT: St,
  OPEN_COMPLETED_QUIZ_AT: Nt,
  OPEN_QUIZ_AT: Rt,
  PAUSE: Ot,
  PLAY: It,
  PLAYBACK_SPEED: Ct,
  PLAYBACK_SPEED_MESSAGE: Pt,
  PREVIOUS_CAPTION_LANGUAGE: Ut,
  PREVIOUS_HIT: Lt,
  QUALITY: Dt,
  QUALITY_MENU: et,
  REPLAY: Mt,
  RESET_PLAYBACK_SPEED: ut,
  RIGHT_ARROW: Gt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Yt,
  SECONDS: Ht,
  SECONDS_other: rt,
  SEEK_BACKWARD: Vt,
  SEEK_FORWARD: Bt,
  SETTINGS: at,
  SHORTCUT: it,
  SIDEBAR: Kt,
  SPACE: mt,
  SPEED_MENU: Ft,
  START_AUTOSCROLL: dt,
  TOGGLE_CAPTIONS: lt,
  TOGGLE_MUTED: ht,
  TOGGLE_PLAY_PAUSE: Wt,
  TRANSCRIPT_LINES: $t,
  TRANSCRIPT_LINES_other: gt,
  TRANSCRIPT_LOADING: Qt,
  TRANSCRIPT_LOAD_ERROR: Jt,
  TRANSCRIPT_OPTIONS: pt,
  TRANSCRIPT_RETRY: xt,
  TRANSCRIPT_UNAVAILABLE: Zt,
  UP_ARROW: Xt,
  VIDEO_SETTINGS: ft,
  VOLUME: qt,
  VOLUME_VALUE: vt
};
export {
  t as A11Y_DURATION,
  A as A11Y_SEARCH_HITS,
  n as A11Y_SEARCH_NO_RESULTS,
  o as A11Y_SEARCH_RESULTS_FOUND,
  E as A11Y_SEARCH_RESULTS_FOUND_other,
  c as A11Y_TIMESTAMP_JUMP_HOURS,
  T as A11Y_TIMESTAMP_JUMP_MINUTES,
  _ as A11Y_TIMESTAMP_JUMP_SECONDS,
  s as A11Y_TRANSCRIPT_ERROR,
  S as A11Y_TRANSCRIPT_LINE,
  N as A11Y_TRANSCRIPT_LINES,
  R as A11Y_TRANSCRIPT_SAVING,
  O as A11Y_TRANSCRIPT_SUCCESS,
  I as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  C as ACTION,
  P as ADD_ANNOTATION_AT,
  U as ADD_QUESTION_AT,
  L as ANNOTATIONS,
  D as AUTO,
  e as AUTO_QUALITY,
  M as BACK,
  u as CAPTIONS,
  G as CAPTIONS_LANGUAGE,
  Y as CAPTIONS_MANAGE,
  H as CAPTION_DELETE,
  r as CAPTION_FONT_SIZE,
  V as CAPTION_LANGUAGE,
  B as CAPTION_LANGUAGE_AUTOMATIC,
  a as CLEAR_SEARCH,
  i as CLOSE,
  K as COMMENTS,
  m as CONTINUE,
  F as DECREASE_PLAYBACK_SPEED,
  d as DECREASE_VOLUME,
  l as DOWN_ARROW,
  h as EDIT_CLOSE,
  W as EDIT_CONFIRM,
  $ as EDIT_ERROR,
  g as EDIT_SAVING,
  Q as EDIT_SUCCESS,
  J as EDIT_TRANSCRIPT,
  p as EDIT_VALIDATION_ERROR,
  x as FULLSCREEN,
  Z as HOURS,
  X as HOURS_other,
  f as INCREASE_PLAYBACK_SPEED,
  q as INCREASE_VOLUME,
  v as INVERT_COLORS,
  y as JUMP_TO_PERCENTAGE,
  z as JUMP_TO_START,
  b as KEBAB_MENU,
  j as KEYBOARD_SHORTCUTS,
  k as LANGUAGE,
  w as LEFT_ARROW,
  tt as MAIN_MENU,
  At as MINUTES,
  nt as MINUTES_other,
  ot as MUTE,
  Et as MUTED,
  ct as NEXT_CAPTION_LANGUAGE,
  Tt as NEXT_HIT,
  _t as OFF,
  st as ON_TOP,
  St as OPEN_ANNOTATION_AT,
  Nt as OPEN_COMPLETED_QUIZ_AT,
  Rt as OPEN_QUIZ_AT,
  Ot as PAUSE,
  It as PLAY,
  Ct as PLAYBACK_SPEED,
  Pt as PLAYBACK_SPEED_MESSAGE,
  Ut as PREVIOUS_CAPTION_LANGUAGE,
  Lt as PREVIOUS_HIT,
  Dt as QUALITY,
  et as QUALITY_MENU,
  Mt as REPLAY,
  ut as RESET_PLAYBACK_SPEED,
  Gt as RIGHT_ARROW,
  Yt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Ht as SECONDS,
  rt as SECONDS_other,
  Vt as SEEK_BACKWARD,
  Bt as SEEK_FORWARD,
  at as SETTINGS,
  it as SHORTCUT,
  Kt as SIDEBAR,
  mt as SPACE,
  Ft as SPEED_MENU,
  dt as START_AUTOSCROLL,
  lt as TOGGLE_CAPTIONS,
  ht as TOGGLE_MUTED,
  Wt as TOGGLE_PLAY_PAUSE,
  $t as TRANSCRIPT_LINES,
  gt as TRANSCRIPT_LINES_other,
  Qt as TRANSCRIPT_LOADING,
  Jt as TRANSCRIPT_LOAD_ERROR,
  pt as TRANSCRIPT_OPTIONS,
  xt as TRANSCRIPT_RETRY,
  Zt as TRANSCRIPT_UNAVAILABLE,
  Xt as UP_ARROW,
  ft as VIDEO_SETTINGS,
  qt as VOLUME,
  vt as VOLUME_VALUE,
  yt as default
};
